var _defs, _g, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProtectError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-1,.cls-2{stroke:#000;}.cls-1{stroke-width:3px;}.cls-2{stroke-width:2px;}.cls-3{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_shield_04") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_814",
    "data-name": "Grupo 814"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_392",
    "data-name": "Trazado 392",
    className: "cls-1",
    d: "M49.43,11.86A35.66,35.66,0,0,1,30,6.1a36.28,36.28,0,0,1-19.72,5.76V34.34c0,10.42,16,19.56,19.72,19.56s19.72-9.14,19.72-19.56V11.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_395",
    "data-name": "Trazado 395",
    className: "cls-2",
    d: "M43,18A23.7,23.7,0,0,1,30.1,14.17,24.11,24.11,0,0,1,17,18V32.93c0,6.92,10.61,13,13.1,13s13.1-6.07,13.1-13V18Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_788",
    "data-name": "Grupo 788"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    className: "cls-3",
    d: "M29.07,34.29a1.15,1.15,0,0,1-.33-.77l-1-10.43,0-.26a1.67,1.67,0,0,1,.57-1.33,2.4,2.4,0,0,1,2.92,0,1.65,1.65,0,0,1,.58,1.33l0,.29-1,10.4a1.2,1.2,0,0,1-.33.78,1,1,0,0,1-1.37,0Zm-.74,5.32a2.1,2.1,0,0,1,0-2.86,2,2,0,0,1,2.84,0,2.1,2.1,0,0,1,0,2.86A2,2,0,0,1,28.33,39.61Z"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: -0.22,
    y: 0.04,
    width: 60,
    height: 60
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProtectError);
export default __webpack_public_path__ + "static/media/icon_protect_error.65f68f42f7f338276aa21a03ef6048a3.svg";
export { ForwardRef as ReactComponent };